import { render, staticRenderFns } from "./DemoBtn.vue?vue&type=template&id=1c739362&scoped=true"
import script from "./DemoBtn.vue?vue&type=script&lang=js"
export * from "./DemoBtn.vue?vue&type=script&lang=js"
import style0 from "./DemoBtn.vue?vue&type=style&index=0&id=1c739362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c739362",
  null
  
)

export default component.exports